











































































































  import Vue from 'vue';
  import {Component, PropSync} from 'vue-property-decorator';
  import {mapGetters} from 'vuex';
  import { AdditionalFiltersData } from '@/types';
  import { objectIsEmpty } from '@/utils';

  @Component({
    name: 'AdditionalFilters',
    props: {
      texts: {
        type: Object,
        default: () => {},
      },
      rules: {
        type: Array,
        default: () => [],
      },
      additionalFiltersOptions: {
        type: Array,
        default: () => [],
      },
      apartment_views: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        activeRules: [...this.rules],
        activeOptions: [...this.additionalFiltersOptions],
        activeApartment_views: [...this.apartment_views],
      };
    },
    computed: {
      ...mapGetters(['filters']),
      filtersNotEmpty(): boolean {
        return !objectIsEmpty(this.filters);
      },
      booleanTypeFilters() {
        return this.filters.additional_filters.filter((item) => item.type === 'boolean' );
      },
    },
    methods: {
      clearFilters() {
        const query = {...this.$route.query};
        if (!!query.options) {
          delete query.options;
          this.$router.push({name: this.$route.name ?? '', query});
        }
        this.activeRules = [];
        this.activeOptions = [];
        this.activeApartment_views = [];
        this.$emit('clearFilters');
      },

    sendAdditionalFilters() {
      let additionalFiltersData: AdditionalFiltersData = Object.assign({} as AdditionalFiltersData,
          {options: this.activeOptions},
          {apartment_views: this.activeApartment_views},
      );
      additionalFiltersData = { ...additionalFiltersData, ...this.parseToRulesQueryString(this.activeRules)};
      this.$emit('sendAdditionalFiltersData', additionalFiltersData);
    },

    parseToRulesQueryString(rulesArray) {
      const queryString = {};
      for (const index in this.booleanTypeFilters) {
        if (this.booleanTypeFilters.hasOwnProperty(index)) {
          for (const filter of this.booleanTypeFilters[index].items) {
            if (!!rulesArray.includes(filter.id)) {
              queryString[filter.id] = 'True';
            } else {
              queryString[filter.id] = false;
            }
          }
        }
      }
      return queryString;
    },
  },
})
export default class AdditionalFilters extends Vue {}
